import { render, staticRenderFns } from "./Losses.vue?vue&type=template&id=79edd4b1"
import script from "./Losses.vue?vue&type=script&lang=js"
export * from "./Losses.vue?vue&type=script&lang=js"
import style0 from "./Losses.vue?vue&type=style&index=0&id=79edd4b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports